$(document).ready(function() {
   $(".globo-formbuilder").animate({opacity:1},200);



 // Get all swatch labels
$(".product-card__info label[data-color-name]").on("click", function () {
  const $label = $(this);

  // Find the nearest .product-card__info and the .swatch_name inside it
  const $productCard = $label.closest(".product-card__info");
  const $swatchNameDiv = $productCard.find(".swatch_name");

  // Add the "hide" class immediately on click
  if ($swatchNameDiv.length) {
    $swatchNameDiv.addClass("hide_0");
  }

  // Delay before updating the swatch name and showing it again
  setTimeout(function () {
    const selectedColor = $label.data("color-name");

    if ($swatchNameDiv.length) {
      $swatchNameDiv.text(selectedColor);
     // $swatchNameDiv.removeClass("hide"); // Remove the hide class after update
    }

    // Toggle active class within this product card
    const $allLabels = $productCard.find("label[data-color-name]");
    $allLabels.removeClass("active");
    $label.addClass("active");
  }, 100); // Delay in milliseconds
});


// cart drawer gift note textarea focus
  $('.cart-drawer__footer-action-button').on('click', function () {
      setTimeout(function() {
       
    $('#cart-drawer cart-note textarea').focus();
     }, 300);
  });




  
});



